import React from "react";
import {EditorField as Editor} from "./editor/editor";
import TextArea from "./TextArea";

export default class TypeTextEditor extends React.Component {
    render() {
        if (!(this.props.componentConfig.fielddefs || {})[this.props.name]) {
            console.log(`No '${this.props.name}' field in '${this.props.componentConfig.componentname}'!`);
            return null;
        }
        return this.props.componentConfig.fielddefs[this.props.name].type === "xmlelement"
            ?
            <div className="form-group"><Editor {...this.props.getFieldProps(this.props.name)} name={this.props.name} component={this.props.componentConfig.componentname} componentId={this.props.data[this.props.componentConfig.idfield]} value={(this.props.data || {})[this.props.name] || ''} label={this.props.label} height="200px" saveChanges={ this.props.setFieldValue }/></div>
            :
            <div className="form-group"><TextArea {...this.props.getFieldProps(this.props.name)} name={this.props.name} value={(this.props.data || {})[this.props.name] || ''} label={this.props.label} saveChanges={this.props.setFieldValue}/></div>
        ;
    }
}